// extracted by mini-css-extract-plugin
export var container = "_56-0";
export var disabled = "_56-4";
export var fullWidth = "_56-3";
export var lined = "_56-1";
export var selected = "_56-5";
export var tab = "_56-2";